import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { APIDestination, DestinationRateLimitPeriod, HTTPDestinationTypeConfig } from '../../../../../../../typings/Destination.interface';
import { APISubscription } from '../../../../../../../typings/Subscription.interface';
import { isFreePlan } from '../../../../utils/subscription';
import SelectInput from '../../../common/Form/Fields/SelectInput';
import TextInput from '../../../common/Form/Fields/TextInput';
import FormError from '../../../common/Form/FormError';
import { useToasts } from '../../../common/Toast';
import Button from '../../../common/base/Button';
import { StyledCardSection } from '../../../common/base/Card';
import Link from '../../../common/base/Link';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DashboardContext } from '../DashboardContext';
import Text from '../../../common/base/Text';
import { getDestinationDeliveryPolicy } from '../Connections/Forms/destination_configuration';
const ChangeRateLimit = t0 => {
  const $ = _c(21);
  const {
    subscription,
    destination,
    onUpdate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    team
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] !== HookdeckAPI.destinations || $[1] !== addToast || $[2] !== destination || $[3] !== onUpdate) {
    t1 = (rate_limit, rate_limit_period) => {
      const delivery_policy = getDestinationDeliveryPolicy(destination);
      HookdeckAPI.destinations.update(destination.id, {
        type: destination.type,
        config: {
          url: (destination.config as HTTPDestinationTypeConfig).url,
          delivery_policy: {
            ...(delivery_policy || {}),
            rate: rate_limit,
            period: rate_limit_period
          }
        }
      }).then(destination_0 => {
        addToast("success", "Max delivery rate updated");
        onUpdate?.(destination_0);
      }).catch(() => {
        addToast("error", "Failed to update max delivery rate");
      });
    };
    $[0] = HookdeckAPI.destinations;
    $[1] = addToast;
    $[2] = destination;
    $[3] = onUpdate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onRateLimitUpdated = t1;
  let t2;
  if ($[5] !== destination) {
    t2 = getDestinationDeliveryPolicy(destination);
    $[5] = destination;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const delivery_policy_0 = t2;
  if (!delivery_policy_0) {
    throw new Error("Invalid destination type");
  }
  const initial_rate_limit = delivery_policy_0.rate;
  const initial_rate_limit_period = delivery_policy_0.period || "second";
  let t3;
  if ($[7] !== onRateLimitUpdated) {
    t3 = values => {
      values.rate_limit && onRateLimitUpdated(values.rate_limit, values.rate_limit_period);
    };
    $[7] = onRateLimitUpdated;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== initial_rate_limit || $[10] !== initial_rate_limit_period) {
    t4 = {
      rate_limit: initial_rate_limit,
      rate_limit_period: initial_rate_limit_period
    };
    $[9] = initial_rate_limit;
    $[10] = initial_rate_limit_period;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== initial_rate_limit || $[13] !== initial_rate_limit_period || $[14] !== subscription || $[15] !== team) {
    t5 = props => {
      const {
        rate_limit: rate_limit_0,
        rate_limit_period: rate_limit_period_0
      } = props.values;
      let show_rate_limit_warning = false;
      if (rate_limit_period_0 !== "concurrent") {
        let rate_limit_per_second = Number(rate_limit_0);
        if (rate_limit_period_0 === "minute") {
          rate_limit_per_second = Number(rate_limit_0) / 60;
        } else {
          if (rate_limit_period_0 === "hour") {
            rate_limit_per_second = Number(rate_limit_0) / 3600;
          }
        }
        if (rate_limit_per_second > team.max_events_per_second) {
          show_rate_limit_warning = true;
        }
      }
      return <Form><StyledCardSection p={3} w={{
          px: 248
        }}><Div flex={{
            gap: 3
          }}><TextInput m={0} w={{
              px: 120
            }} name="rate_limit" placeholder="50" type="number" min={0} show_error={false} /><SelectInput m={0} name="rate_limit_period" options={[{
              value: "second",
              label: "per second"
            }, {
              value: "minute",
              label: "per minute"
            }, {
              value: "hour",
              label: "per hour"
            }, {
              value: "concurrent",
              label: "concurrent"
            }]} required={true} /></Div><FormError field="rate_limit" error_limit={1}>{field => field === "rate_limit" && isFreePlan(subscription.plan) && <Div m={{
              t: 2
            }}><Link to="/settings/organization/plans">You can upgrade to increase limit.</Link></Div>}</FormError>{show_rate_limit_warning && <Text muted={true} size="s" m={{
            t: 1
          }}>Delivery to this destination is capped at your project throughput of{" "}{team?.max_events_per_second} events per second. A max delivery rate above that has no effect.{" "}<Link icon="arrow_forward" to="/settings/project/quotas?view=throughput">Increase it</Link></Text>}</StyledCardSection><StyledCardSection p={{
          x: 4,
          y: 3
        }}><Button submit={true} primary={true} disabled={!rate_limit_0 || !rate_limit_period_0 || props.values.rate_limit === initial_rate_limit && props.values.rate_limit_period === initial_rate_limit_period}>Update</Button></StyledCardSection></Form>;
    };
    $[12] = initial_rate_limit;
    $[13] = initial_rate_limit_period;
    $[14] = subscription;
    $[15] = team;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <Formik onSubmit={t3} validateOnBlur={false} initialValues={t4}>{t5}</Formik>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default ChangeRateLimit;